import { configureStore } from "@reduxjs/toolkit";
//
import authSlice from "./Data/features/authSlice";
import dashboardReducer from "./Data/features/dashboardSlice";
import postReportReducer from "./Data/features/postReportSlice";
import postReducer from "./Data/features/postSlice";
import settingsReducer from "./Data/features/settingsSlice";
import subscriptionReducer from "./Data/features/subscriptionSlice";
import userReducer from "./Data/features/userSlice";
//
import sessionMiddleware from "./Data/middleware/sessionMiddleware";
import { baseApi } from "./Data/services/baseApi";
// Side-effect imports: register endpoints via baseApi.injectEndpoints()
import "./Data/services/deeplinkApi";
import "./Data/services/dashboardApi";
import "./Data/services/notificationApi";
import "./Data/services/postApi";
import "./Data/services/postReportApi";
import "./Data/services/settingApi";
import "./Data/services/userApi";
import "./Data/services/userAuthApi";

export const store = configureStore({
  reducer: {
    // RTK Query API (all services inject into baseApi)
    [baseApi.reducerPath]: baseApi.reducer,
    //
    //
    // Local storage Redux
    auth: authSlice,
    dashboard: dashboardReducer,
    setting: settingsReducer,
    user: userReducer,
    // subscription: subscriptionReducer,
    posts: postReducer,
    postReport: postReportReducer,
  },
  // load from local storage
  // preloadedState: loadFromLocalStorage(), //todo:

  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  //todo:
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      baseApi.middleware,
      sessionMiddleware, // for session check each api response
    ]),
});

//todo:
// function saveToLocalStorage(state) {
//     try {
//         const serialState = JSON.stringify(state)
//         localStorage.setItem("reduxStore", serialState)
//     } catch (e) {
//         console.warn(e);
//     }
// }

//todo:
// function loadFromLocalStorage() {
//     try {
//         const serialisedState = localStorage.getItem("reduxStore");
//         if (serialisedState === null) return undefined;
//         return JSON.parse(serialisedState);
//     } catch (e) {
//         console.warn(e);
//         return undefined;
//     }
// }

//todo:
// store.subscribe(() => saveToLocalStorage(store.getState()));

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
// setupListeners(store.dispatch) //todo:
